/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.menu', [])
    .factory('menu', Menu)
    .name;

/*@ngInject*/
function Menu(userService, $state, $rootScope, types) {

    var authority = '';
    var sections = [];
    var homeSections = [];

    if (userService.isUserLoaded() === true) {
        buildMenu();
    }

    var authenticatedHandle = $rootScope.$on('authenticated', function () {
        buildMenu();
    });

    var service = {
        authenticatedHandle: authenticatedHandle,
        getHomeSections: getHomeSections,
        getSections: getSections,
        sectionHeight: sectionHeight,
        sectionActive: sectionActive
    }

    return service;

    function getSections() {
        return sections;
    }

    function getHomeSections() {
        return homeSections;
    }

    function buildMenu() {
        var user = userService.getCurrentUser();
        if (user) {
            if (authority !== user.authority) {
                sections = [];
                authority = user.authority;
                if (authority === types.authority.SYS_ADMIN.value ||
                    authority === types.authority.SYS_USER.value) {
                    sections = [
                        {
                            name: 'home.home',
                            type: 'link',
                            state: 'home.links',
                            icon: 'home'
                        },
                        {
                            name: 'user.users',
                            type: 'link',
                            state: 'home.users',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'subscription.subscriptions',
                            type: 'link',
                            state: 'home.providerSubscriptions',
                            icon: 'subscriptions'
                        },
                        {
                            name: 'provider.providers',
                            type: 'link',
                            state: 'home.providers',
                            svgIcon: 'tk:providers'
                        },
                        {
                            name: 'hardware-entities.entities',
                            type: 'toggle',
                            state: 'home.hardware-entities',
                            height: '80px',
                            icon: 'devices',
                            pages: [
                                {
                                    name: 'gateway.gateways',
                                    type: 'link',
                                    state: 'home.hardware-entities.gateway',
                                    icon: 'router'
                                },
                                {
                                    name: 'device.devices',
                                    type: 'link',
                                    state: 'home.hardware-entities.device',
                                    icon: 'devices_other'
                                }
                            ]
                        },
                        {
                            name: 'admin.system-settings',
                            type: 'toggle',
                            state: 'home.settings',
                            height: '120px',
                            icon: 'settings',
                            pages: [
                                {
                                    name: 'admin.general',
                                    type: 'link',
                                    state: 'home.settings.general',
                                    icon: 'settings_applications'
                                },
                                {
                                    name: 'admin.outgoing-mail',
                                    type: 'link',
                                    state: 'home.settings.outgoing-mail',
                                    icon: 'mail'
                                },
                                {
                                    name: 'admin.sms',
                                    type: 'link',
                                    state: 'home.settings.sms',
                                    icon: 'sms'
                                }
                            ]
                        }];
                    homeSections =
                        [{
                            name: 'user.management',
                            places: [
                                {
                                    name: 'user.users',
                                    icon: 'supervisor_account',
                                    state: 'home.users'
                                }
                            ]
                        },
                        {
                            name: 'subscription.management',
                            places: [
                                {
                                    name: 'providerSubscription.providerSubscriptions',
                                    icon: 'subscriptions',
                                    state: 'home.providerSubscriptions'
                                }
                            ]
                        },
                        {
                            name: 'provider.management',
                            places: [
                                {
                                    name: 'provider.providers',
                                    svgIcon: 'tk:providers',
                                    state: 'home.providers'
                                }
                            ]
                        },
                        {
                            name: 'hardware-entities.entities',
                            places: [
                                {
                                    name: 'gateway.gateways',
                                    icon: 'router',
                                    state: 'home.hardware-entities.gateway'
                                },
                                {
                                    name: 'device.devices',
                                    icon: 'devices_other',
                                    state: 'home.hardware-entities.device'
                                }
                            ]
                        },
                        {
                            name: 'admin.system-settings',
                            places: [
                                {
                                    name: 'admin.general',
                                    icon: 'settings_applications',
                                    state: 'home.settings.general'
                                },
                                {
                                    name: 'admin.outgoing-mail',
                                    icon: 'mail',
                                    state: 'home.settings.outgoing-mail'
                                },
                                {
                                    name: 'admin.sms',
                                    icon: 'sms',
                                    state: 'home.settings.sms'
                                }
                            ]
                        }];
                } else if (authority === types.authority.PROVIDER_ADMIN.value ||
                           authority === types.authority.PROVIDER_USER.value) {
                    sections = [
                        {
                            name: 'home.home',
                            type: 'link',
                            state: 'home.links',
                            icon: 'home'
                        },
                        {
                            name: 'user.users',
                            type: 'link',
                            state: 'home.users',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'gateway-model.gateway-models',
                            type: 'link',
                            state: 'home.gatewayModels',
                            icon: 'router'
                        },
                        {
                            name: 'gateway-group.gateway-groups',
                            type: 'link',
                            state: 'home.gatewayGroups',
                            icon: 'router'
                        },
                        {
                            name: 'subscription.subscriptions',
                            type: 'link',
                            state: 'home.customerSubscriptions',
                            icon: 'subscriptions'
                        },
                        {
                            name: 'customer.customers',
                            type: 'link',
                            state: 'home.customers',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'gateway-log.gateway-logs',
                            type: 'link',
                            state: 'home.gatewayLogs',
                            icon: 'track_changes'
                        },
                        {
                            name: 'alarm.alarms',
                            type: 'link',
                            state: 'home.alarms',
                            icon: 'notifications_active'
                        }];

                    homeSections =
                        [{
                            name: 'user.management',
                            places: [
                                {
                                    name: 'user.users',
                                    icon: 'supervisor_account',
                                    state: 'home.users'
                                }
                            ]
                        },
                        {
                            name: 'gateway.management',
                            places: [
                                {
                                    name: 'gateway-model.gateway-models',
                                    icon: 'router',
                                    state: 'home.gatewayModels'
                                },
                                {
                                    name: 'gateway-group.gateway-groups',
                                    icon: 'router',
                                    state: 'home.gatewayGroups'
                                }
                            ]
                        },
                        {
                            name: 'subscription.management',
                            places: [
                                {
                                    name: 'customerSubscription.customerSubscriptions',
                                    icon: 'subscriptions',
                                    state: 'home.customerSubscriptions'
                                }
                            ]
                        },
                        {
                            name: 'customer.management',
                            places: [
                                {
                                    name: 'customer.customers',
                                    icon: 'supervisor_account',
                                    state: 'home.customers'
                                }
                            ]
                        },
                        {
                            name: 'gateway-log.gateway-logs',
                            places: [
                                {
                                    name: 'gateway-log.gateway-logs',
                                    icon: 'track_changes',
                                    state: 'home.gatewayLogs'
                                }
                            ]
                        },
                        {
                            name: 'alarm.browse-alarms',
                            places: [
                                {
                                    name: 'alarm.alarms',
                                    icon: 'notifications_active',
                                    state: 'home.alarms'
                                }
                            ]
                        }];
                } else if (authority === types.authority.CUSTOMER_ADMIN.value ||
                           authority === types.authority.CUSTOMER_USER.value) {
                    sections = [
                        {
                            name: 'home.home',
                            type: 'link',
                            state: 'home.links',
                            icon: 'home'
                        },
                        {
                            name: 'user.users',
                            type: 'link',
                            state: 'home.users',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'gateway-group.gateway-groups',
                            type: 'link',
                            state: 'home.gatewayGroups',
                            icon: 'router'
                        },
                        {
                            name: 'device-model.device-models',
                            type: 'link',
                            state: 'home.deviceModels',
                            icon: 'devices_other'
                        },
                        {
                            name: 'converter.converters',
                            type: 'link',
                            state: 'home.converters',
                            icon: 'transform'
                        },
                        {
                            name: 'application.applications',
                            type: 'link',
                            state: 'home.applications',
                            icon: 'apps'
                        },
                        {
                            name: 'subCustomer.subCustomers',
                            type: 'link',
                            state: 'home.subCustomers',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'gateway-log.gateway-logs',
                            type: 'link',
                            state: 'home.gatewayLogs',
                            icon: 'track_changes'
                        },
                        {
                            name: 'alarm.alarms',
                            type: 'link',
                            state: 'home.alarms',
                            icon: 'notifications_active'
                        }
                    ];

                    homeSections =
                        [{
                            name: 'user.management',
                            places: [
                                {
                                    name: 'user.users',
                                    icon: 'supervisor_account',
                                    state: 'home.users'
                                }
                            ]
                        },
                        {
                            name: 'gateway.management',
                            places: [
                                {
                                    name: 'gateway-group.gateway-groups',
                                    icon: 'router',
                                    state: 'home.gatewayGroups'
                                }
                            ]
                        },
                        {
                            name: 'device-model.management',
                            places: [
                                {
                                    name: 'device-model.device-models',
                                    icon: 'devices_other',
                                    state: 'home.deviceModels'
                                }
                            ]
                        },
                        {
                            name: 'converter.management',
                            places: [
                                {
                                    name: 'converter.converters',
                                    icon: 'transform',
                                    state: 'home.converters'
                                }
                            ]
                        },
                        {
                            name: 'application.management',
                            places: [
                                {
                                    name: 'application.applications',
                                    icon: 'apps',
                                    state: 'home.applications'
                                }
                            ]
                        },
                        {
                            name: 'subCustomer.management',
                            places: [
                                {
                                    name: 'subCustomer.subCustomers',
                                    icon: 'supervisor_account',
                                    state: 'home.subCustomers'
                                }
                            ]
                        },
                        {
                            name: 'gateway-log.gateway-logs',
                            places: [
                                {
                                    name: 'gateway-log.gateway-logs',
                                    icon: 'track_changes',
                                    state: 'home.gatewayLogs'
                                }
                            ]
                        },
                        {
                            name: 'alarm.browse-alarms',
                            places: [
                                {
                                    name: 'alarm.alarms',
                                    icon: 'notifications_active',
                                    state: 'home.alarms'
                                }
                            ]
                        }];
                } else if (authority === types.authority.SUB_CUSTOMER_ADMIN.value ||
                           authority === types.authority.SUB_CUSTOMER_USER.value) {
                    sections = [
                        {
                            name: 'home.home',
                            type: 'link',
                            state: 'home.links',
                            icon: 'home'
                        },
                        {
                            name: 'user.users',
                            type: 'link',
                            state: 'home.users',
                            icon: 'supervisor_account'
                        },
                        {
                            name: 'application.applications',
                            type: 'link',
                            state: 'home.applications',
                            icon: 'apps'
                        }
                    ];

                    homeSections =
                        [{
                            name: 'user.management',
                            places: [
                                {
                                    name: 'user.users',
                                    icon: 'supervisor_account',
                                    state: 'home.users'
                                }
                            ]
                        },
                        {
                            name: 'application.management',
                            places: [
                                {
                                    name: 'application.applications',
                                    icon: 'apps',
                                    state: 'home.applications'
                                }
                            ]
                        }];
                }
            }
        }
    }

    function sectionHeight(section) {
        if ($state.includes(section.state)) {
            return section.height;
        } else {
            return '0px';
        }
    }

    function sectionActive(section) {
        return $state.includes(section.state);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/menu.service.js